import React from 'react';
import Buttons from './../forms/buttons/index.jsx';
import { systemText } from './../../helpers/string/index.js';

export const ConfirmButton = ({ defaultChoice = false, helpText, children }) => {
	const [showYesNo, setShowYesNo] = React.useState(false);
	const [choice] = React.useState(defaultChoice);

	// check that children is a single React element and returns it. If more than one child is passed, will throw an error.
	const child = React.Children.only(children);

	// If no handler so nothing to run if "Yes" pressed, return passed-in HTML as is
	if (!child.props.onClick) {
		return children;
	}

	const childWithoutOnClick = React.cloneElement(child, {
		onClick: undefined, // remove the handler
	});

	// First, just show the passed-in HTML without its handler, but if it is clicked, activate the buttons below
	if (!showYesNo) {
		return <span onClick={() => setShowYesNo(true)}>{childWithoutOnClick}</span>;
	}

	const noSelected = () => {
		setShowYesNo(false);
	};

	return (
		<Buttons
			id="confirm-button-form"
			data-testid="confirm-button-form"
			label={childWithoutOnClick}
			mandatory={false}
			forceHelp={helpText ? true : false}
			help={helpText}
		>
			<div className="flex mt5">
				<button
					data-testid="button-yes"
					className={`btn ${choice === true ? 'btn-primary aria-checked="true"' : 'btn-default aria-checked="false"'}`}
					onClick={e => child.props.onClick?.(e)}
					value={child.props.value}
					name={child.props.name}
				>
					<i className="fa fa-thumbs-up mr50" />
					{systemText('General/Controls/Warning/Buttons/Yes')}
				</button>
				<button
					data-testid="button-no"
					className={`btn ${choice === false ? 'btn-primary aria-checked="true"' : 'btn-default aria-checked="false"'}`}
					onClick={() => noSelected()}
				>
					<i className="fa fa-thumbs-down mr50" />
					{systemText('General/Controls/Warning/Buttons/No')}
				</button>
			</div>
		</Buttons>
	);
};

export default ConfirmButton;
